// @flow

export const PRODUCT = {
  NONE: 'NONE',
  SLR: 'SLR',
  HELOC: 'HELOC',
  MORTGAGE_REFI: 'MORTGAGE_REFI',
};
